import { AsyncPaginate } from "react-select-async-paginate";
import axios, { CancelTokenSource } from "axios";
import { useContext, useEffect, useState } from "react";
import { constants } from "script/constant";
import { authContext } from "auth/auth.provider";
import AvishButton from "./button/button";

interface IUserSelect {
    onChange: (value: any) => void;
    value?: any;
    defaultUserId?: number | undefined | null;
    isMultiSelect?: boolean;
    [key: string]: any;
}

const GetListOfUsersToLoad: React.FC<IUserSelect> = ({
    onChange,
    value,
    defaultUserId,
    isMultiSelect,
    ...props
}) => {
    const { user: authUser, appPermission } = useContext(authContext);
    const [isLoadingR, setLoading] = useState(false);

    const [selectedOption, setSelectedOption] = useState<any>(null);
    const [options, setOptions] = useState<any[]>([]);
    const [cancelToken, setCancelToken] = useState<CancelTokenSource | null>(null);

    // useEffect(() => {
    //     if (syncInitiatedUser && syncInitiatedUser.userID !== 0) {
    //         const option = {
    //             value: syncInitiatedUser.userID,
    //             label: syncInitiatedUser.userName,
    //             email: syncInitiatedUser.userEmail,
    //         };
    //         setSelectedOption(option);
    //         setOptions([option]);
    //         onChange(option);
    //     } else if (value) {
    //         setSelectedOption(value);
    //         setOptions([value]);
    //     }
    // }, [syncInitiatedUser, value]);

    const loadUserOptions = async () => {
        if (cancelToken) cancelToken.cancel("Cancelled previous request");
        const source = axios.CancelToken.source();
        setCancelToken(source);

        const response = await axios.get(constants.GET_USER_OPTIONS_TO_LOAD, {
            cancelToken: source.token,
        });

        const opts = response.data.map((item: any) => ({
            value: item.userID,
            label: item.userName,
            email: item.userEmail,
        }));

        // ensure selected user stays in options
        const merged = [
            ...(selectedOption ? [selectedOption] : []),
            ...opts.filter((o: any) => o.value !== selectedOption?.value),
        ];

        setOptions(merged);
        return { options: opts };
    };

    const loadUser = () => {
        if (!selectedOption?.value) return;
        setLoading(true);
        axios
            .get(constants.LOAD_USER_AS_DESIGNATED_USER + "/" + selectedOption.value)
            .then(() => {
                window.location.reload();
            })
            .finally(() => setLoading(false));
    };

    const unloadUser = () => {
        setSelectedOption(null);
        setLoading(true);
        axios
            .delete(constants.UNLOAD_SYNC_DESIGNATED_USER)
            .then(() => window.location.reload())
            .finally(() => setLoading(false));
    };

    return (
        <>
            {appPermission.allowSetUserInAdmin == true && (
                <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                    {authUser.syncInitiatedUserID == 0 && (
                        <AsyncPaginate
                            isMulti={isMultiSelect}
                            value={selectedOption}
                            defaultOptions={options}
                            loadOptions={loadUserOptions}
                            getOptionLabel={(option) => option.label}
                            getOptionValue={(option) => option.value.toString()}
                            onChange={(val) => {
                                setSelectedOption(val);
                                onChange(val);
                            }}
                            styles={{
                                container: (base) => ({
                                    ...base,
                                    width: "200px",
                                }),
                            }}
                            {...props}
                        />
                    )}

                    {authUser?.syncInitiatedUserID != 0 ? (
                        <AvishButton
                            value="Unload"
                            type="button"
                            color="danger"
                            onClick={unloadUser}
                            isButtonLoading={isLoadingR}
                            style={{ margin: "4px 4px 0px 4px" }}
                        />
                    ) : (
                        <AvishButton
                            value="Set User"
                            type="button"
                            color="primary"
                            isButtonDisabled={!selectedOption || selectedOption?.value == authUser.userID}
                            isButtonLoading={isLoadingR}
                            onClick={loadUser}
                            style={{ margin: "4px 4px 0px 4px" }}
                        />
                    )}
                </div>
            )}
        </>
    );
};

export default GetListOfUsersToLoad;
